import { InvoicesPage, InvoiceCreatePage } from '@/features/portal/InvoicesPage';
import { SettingsPage, PreferencesPage } from '@/features/settings/SettingsPage';
import { AccountPage } from '@/features/account/AccountPage';
import { Navigate, Route, Routes } from 'react-router';

import { PortalLayout } from '@/app/layouts/PortalLayout';
import { LoginPage } from '@/features/auth/pages/LoginPage';
import { PasswordResetPage } from '@/features/auth/pages/PasswordResetPage';
import { LeavesPage } from '@/features/leaves/LeavesPage';
import { MessagesPage } from '@/features/messages/MessagesPage';
import { MissionDetailPage } from '@/features/portal/MissionDetailPage';
import { MissionsPage } from '@/features/portal/MissionsPage';
import { TimesheetSatisfactionPage } from '@/features/timesheets/TimesheetSatisfactionPage';
import { TimesheetPage } from '@/features/timesheets/TimesheetPage';
import { TimesheetsPage } from '@/features/timesheets/TimesheetsPage';

import { RequireAuth } from './RequireAuth';
import { ROUTES } from './routes';

/**
 * Table de routage du portail.
 *
 * ── Pourquoi aucun `lazy()` ──────────────────────────────────────────────
 * L'outil interne diffère ses pages parce qu'il en compte une vingtaine et
 * que la plupart des sessions n'en ouvrent que deux. Le portail en a cinq,
 * toutes visitées dans la même session : les découper produirait cinq
 * allers-retours réseau pour épargner quelques kilo-octets au premier rendu.
 *
 * La garde enveloppe le **gabarit**, et non chaque page : une route ajoutée
 * ici est protégée d'office. L'oubli inverse — protéger page par page — est la
 * façon la plus courante de laisser fuiter un écran.
 */
export const AppRouter = () => (
  <Routes>
    <Route path={ROUTES.login} element={<LoginPage />} />
    <Route path={ROUTES.passwordReset} element={<PasswordResetPage />} />

    <Route
      element={
        <RequireAuth>
          <PortalLayout />
        </RequireAuth>
      }
    >
      <Route path="/factures" element={<InvoicesPage />} />
      <Route path="/factures/nouvelle" element={<InvoiceCreatePage />} />
      <Route path={ROUTES.settings} element={<SettingsPage />} />
      <Route path={ROUTES.preferences} element={<PreferencesPage />} />
      <Route path={ROUTES.account} element={<AccountPage />} />
      <Route path={ROUTES.timesheets} element={<TimesheetsPage />} />
      <Route path={ROUTES.timesheet(':id')} element={<TimesheetPage />} />
      <Route path={ROUTES.timesheetSatisfaction(':id')} element={<TimesheetSatisfactionPage />} />
      <Route path={ROUTES.leaves} element={<LeavesPage />} />
      <Route path={ROUTES.missions} element={<MissionsPage />} />
      <Route path={ROUTES.mission(':id')} element={<MissionDetailPage />} />
      <Route path={ROUTES.messages} element={<MessagesPage />} />
    </Route>

    {/* Tout le reste ramène aux CRA : le portail n'a pas de page d'accueil
        distincte, et une 404 dédiée serait un écran de plus à maintenir pour
        une application de cinq pages. */}
    <Route path="*" element={<Navigate to={ROUTES.timesheets} replace />} />
  </Routes>
);
